import apiInstance from '../../../backend-api.setup'
import { ApiPathConfig } from '../../../../config/ApiPathConfig'

const deletePrivateReportsService = (id: string): Promise<void> => {
  return apiInstance.delete(ApiPathConfig.PRIVATE_REPORTS_BY_ID(id))
}

export default deletePrivateReportsService
